import { render, staticRenderFns } from "./yz_ws_caijue.vue?vue&type=template&id=7f4e7aff&scoped=true"
import script from "./yz_ws_caijue.vue?vue&type=script&lang=js"
export * from "./yz_ws_caijue.vue?vue&type=script&lang=js"
import style0 from "./yz_ws_caijue.vue?vue&type=style&index=0&id=7f4e7aff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4e7aff",
  null
  
)

export default component.exports